import { connect } from 'react-redux';

import { uncurlyUuid } from '@atlassian/bitkit-analytics';

import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState, BucketDispatch } from 'src/types/state';

import toggleCloneDialog from '../actions/toggle-clone-dialog';
import CloneButton from '../components/clone-button';

const mapStateToProps = (state: BucketState) => {
  const repository = getCurrentRepository(state);
  return {
    repositoryUuid: repository ? uncurlyUuid(repository.uuid) : '',
    workspaceUuid: repository?.workspace
      ? uncurlyUuid(repository.workspace.uuid)
      : '',
  };
};

const mapDispatchToProps = (dispatch: BucketDispatch) => ({
  onOpenCloneDialog: () => dispatch(toggleCloneDialog(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CloneButton);
